import React from 'react';
import { color, layout, space } from 'styled-system';
import styled from '@marvelapp/styled';
import { cursor, fill, hoverColor, hoverFill, transition, } from '../customProperties';
import { getDOMProps } from '../utils';
export const Svg = styled((props) => React.createElement("svg", Object.assign({}, getDOMProps(props)))) `
  ${color};
  ${cursor};
  ${fill};
  ${layout};
  ${space};
  ${transition};

  &:hover {
    ${hoverColor};
    ${hoverFill};
  }
`;
